import { render, staticRenderFns } from "./tags.page.vue?vue&type=template&id=45f39714&"
import script from "./tags.page.vue?vue&type=script&lang=js&"
export * from "./tags.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports